import { SUPPORT_EMAIL, SUPPORT_EMAIL_HREF, SUPPORT_PHONE, SUPPORT_PHONE_HREF } from "./contact";
import { link, type Copy } from "./types";

export const ACCESSIBILITY_PATH = "/accessibility";

export const ACCESSIBILITY = {
  eyebrow: "Accessibility",
  title: "Built for everyone",
  intro:
    "VARIANT3D wants everyone to be able to use this site, including people who rely on screen readers, keyboard navigation, magnification or reduced motion. The pages at loop.variant3d.io/home are built to meet the Web Content Accessibility Guidelines (WCAG) 2.2 at Level AA.",
  commitmentsLabel: "What that means here",
  commitments: [
    "Every page has landmarks, headings and a skip link, so screen readers can jump straight to the content.",
    "Every image, chart and video carries a text description.",
    "Everything works with a keyboard, and the focused control is always visible.",
    "Text and controls meet the WCAG contrast ratios.",
    "Animation and autoplaying video stop when your system asks for reduced motion, and every moving element has a pause control.",
    "Pages reflow down to a 320-pixel-wide screen and 400% zoom without sideways scrolling.",
  ],
  feedbackLabel: "Tell us what got in your way",
  feedback: [
    "If something on this site gets in your way, email ",
    link(SUPPORT_EMAIL, SUPPORT_EMAIL_HREF),
    " or call ",
    link(SUPPORT_PHONE, SUPPORT_PHONE_HREF),
    ". Mention the page and what happened, and we will fix it.",
  ] as Copy,
  reviewed: "This statement was last reviewed on 17 September 2026.",
} as const;
